import { Chip } from "@components/atoms/Chip"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { EditableText, defineBlock } from "eddev/blocks"
import { Link } from "eddev/routing"
import { twMerge } from "tailwind-merge"
import * as Icons from "@components/atoms/Icons"

export const meta: BlockMeta = {
  title: "Link Group With Images",
  category: "common",
  icon: "car",
  tags: ["root"],
  editMode: "preview",
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/link-group-with-images", (props) => {
  return (
    <div className="grid-auto gap-6 py-8">
      <div className="col-span-12 md:col-span-10 lg:col-span-8 md:col-start-3 lg:col-start-3 flex flex-col items-center justify-center !text-center gap-4">
        <EditableText as="span" store="subtitle" className="type-label-caps text-mid-grey" placeholder="Subtitle..." />
        <EditableText
          as={props.style ? "h4" : "h3"}
          store="title"
          className={twMerge(props.style ? "!type-title-s" : "!type-title-m")}
          placeholder="Title..."
        />
      </div>

      {props.style ? (
        <>
          {props.links?.map((item, i) => (
            <div
              key={i}
              className="relative col-span-12 md:col-span-4 flex gap-4 p-4 bg-bg border border-grey rounded-md hover:-translate-y-[3px] hover:shadow-[0px_6px_12px_0px_rgba(34,34,34,0.08),0px_1px_3px_0px_rgba(34,34,34,0.1)] aaa-animate"
            >
              {item?.link?.url && <Link href={item?.link?.url} className="z-10 absolute top-0 left-0 w-full h-full" />}
              {item?.image && (
                <ResponsiveImage
                  {...item.image}
                  objectFit="cover"
                  className="aspect-square overflow-hidden rounded-sm"
                />
              )}

              <div className="flex flex-col h-full items-start justify-between">
                <h4 className="!type-title-xs !text-center w-full">{item?.title}</h4>
                <Chip color="outline">{item?.chip}</Chip>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {props.links?.map((item, i) => (
            <Link
              href={item?.link?.url}
              key={i}
              className="col-span-12 md:col-span-4 flex flex-col gap-4 p-4 bg-light-grey rounded-md md:hover:-translate-y-[12px] hover:z-20 group aaa-animate !duration-300"
            >
              <h4 className="type-title-s !text-center w-full">{item?.title}</h4>
              {item?.image && (
                <ResponsiveImage
                  {...item.image}
                  objectFit="cover"
                  className="aspect-video overflow-hidden rounded-sm"
                />
              )}

              <div className="md:absolute md:-mt-4 md:-ml-4 w-full md:top-full h-0 overflow-hidden bg-light-grey rounded-b-md group-hover:h-[calc(32px+(var(--spacing-4)*1))] group-hover:md:h-[calc(32px+(var(--spacing-4)*2))] aaa-animate !duration-300">
                <div className="pt-4 md:p-4 w-full">
                  <button className="w-full flex items-center text-black justify-between bg-yellow rounded-sm type-label-m h-[32px] px-2 box-border">
                    <span>{item?.buttonText}</span>
                    {Icons["ARROW_RIGHT"]}
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </>
      )}
    </div>
  )
})
